module.exports = __webpack_public_path__ + "img/img2.3744d849.png";